import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Input,
  FormGroup,
  Label,
  Button,
  FormText,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { bulkUploadMachines } from "../bulkUploadRedux/dispatcher";
import toast from "react-hot-toast";
import { errorBulkUpload } from "../bulkUploadRedux/action";
import BulkUploadGuide from "./BulkUploadGuide";

function BulkUpload({
  isBulkUploadView,
  setIsBulkUploadView,
  sampelDownLoader,
}) {
  const dispatch = useDispatch();
  // const companyListData = useSelector((state) => state?.companyListReducer);

  // const [modal, setModal] = useState(true);
  // const [selectedCompany, setSelectedCompany] = useState("");
  const [file, setFile] = useState(null);
  // const [companyList, setComapnyList] = useState(
  //   companyListData?.data?.data || []
  // );
  const isLoading = useSelector((state) => state?.bulkUploadReducer?.isLoading);

  const toggle = () => {
    setIsBulkUploadView(false);
    dispatch(errorBulkUpload(""));
  };

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      const fileExtension = uploadedFile.name.split(".").pop().toLowerCase();
      if (["xls", "xlsx"].includes(fileExtension)) {
        setFile(uploadedFile);
      } else {
        toast.error("Please upload a valid Excel file.");
      }
    }
    // Reset input field value so selecting the same file again triggers onChange
    e.target.value = "";
  };

  const handleUpload = () => {
    if (!file) {
      toast.error("No file selected.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    dispatch(bulkUploadMachines(formData, toggle));
    setFile(null);
  };

  return (
    <div>
      <Modal
        isOpen={isBulkUploadView}
        size="lg"
        toggle={toggle}
        className={`custom-right-modal ${isBulkUploadView ? "show" : ""}`}
      >
        <ModalHeader toggle={toggle}>Bulk Upload</ModalHeader>
        <ModalBody>
          <Container fluid>
            {/* <FormGroup>
              <Label for="companySelect">Select Company <span style={{color:"red"}}>*</span></Label>
              <Input
                type="select"
                id="companySelect"
                value={selectedCompany}
                onChange={handleCompanyChange}
                className="w-50"
              >
                <option value="">Select Company</option>
                {companyList.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.company_name}
                  </option>
                ))}
              </Input>
            </FormGroup> */}
            <FormGroup
              className="d-flex align-items-center"
              style={{ gap: "0.5rem" }}
            >
              <Label for="upload" style={{ borderBottom: "2px solid grey" }}>
                Attach Excel File
              </Label>
              <Input
                type="file"
                id="upload"
                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleFileUpload}
                hidden
              />

              <Label
                for="upload"
                // className="btn btn-primary ml-2"
                style={{
                  cursor: "pointer",
                  background: "black",
                  padding: "10px 12px",
                  textAlign: "center",
                  color: "white",
                }}
              >
                {/* <i class="fa-solid fa-upload"></i> */}
                <span>Choose File</span>
              </Label>

              {file ? (
                <FormText color="muted">{file.name}</FormText>
              ) : (
                "No file chosen"
              )}
            </FormGroup>
            <BulkUploadGuide sampelDownLoader={sampelDownLoader} />
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpload} disabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : "Upload"}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default BulkUpload;
